<script>
import ListingModel from "@/views/Evaluation/File/Components/ListingModel.vue"

export default {
    components: {ListingModel}
}
</script>

<template>
    <ListingModel
        type="EVALUATION_PERFORMANCE"
        rootPath="evaluation_performance_goal_files"
    />
</template>